var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('keep-alive',{attrs:{"include":"audits-api-audits"}},[_c(_vm.currentTabComponent,{ref:"subComponent",tag:"component",attrs:{"contData":_vm.contData,"formType":_vm.formType,"from":_vm.from},on:{"changeTab":_vm.changeTab}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }